import React, { lazy, Suspense } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { logAnalyticsEvent } from "../../utils/firebase";

const ListViewCommon = lazy(() => import("./ListViewCommon"));

/**
 * ListView component displays a list of trails.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.navigation - The navigation object used to navigate between screens.
 * @returns {JSX.Element} The ListView component.
 */
const ListView = ({ navigation }) => {
  logAnalyticsEvent("screen_view", { name: "Trails-ListView" });

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ListViewCommon navigation={navigation} FontAwesomeIcon={FontAwesomeIcon} />
    </Suspense>
  );
};

export default ListView;
